import { createModule } from 'saga-slice';
import { crudReducers, failReducer } from 'saga-slice-helpers';
import { sagaApi } from '#/apis';
import { mapToId } from '#/meta';

const sagaSlice = createModule({

    name: 'units',
    initialState: {
        isFetching: false,
        data: {},
        pricing: {},
        error: null
    },

    // Reducers object is the bread and butter of saga slice.
    // Defining a reducer also defines a type and action.
    // The type will be `todos/fetch`, using the pattern of `{name}/{key}`
    reducers: crudReducers({

        fetchPricing: state => {
            state.isFetching = true;
        },
        fetchPricingSuccess: (state, payload) => {
            state.pricing = mapToId(payload, 'unit');
            state.isFetching = false;
        },
        fetchPricingFail: failReducer

    }),

    // The sagas option is a function that gets passed the Actions object.
    // Actions are converted into strings which are the value of its
    // corresponding type. You can also use the actions object to dispatch
    // actions from sagas using the `put` effect.
    sagas: A => ({
        [A.readOne]: {
            *saga({ payload }) {
                const {
                    propertyId, unitId
                } = payload;
                yield sagaApi.get(
                    `/properties/${propertyId}/units/${unitId}`,
                    A.readOneSuccess,
                    A.readOneFail
                );
            }
        },
        [A.readAll]: {
            *saga({ payload: propertyId }) {

                yield sagaApi.get(
                    `/properties/${propertyId}/units`,
                    A.readAllSuccess,
                    A.readAllFail
                );
            }
        },
        [A.fetchPricing]: {
            *saga({ payload: propertyId }) {
                yield sagaApi.get(
                    `/properties/${propertyId}/pricing`,
                    A.fetchPricingSuccess,
                    A.fetchPricingFail
                );
            }
        }
    })
});

// Export actions for convenience when importing from other modules
export const { actions } = sagaSlice;
export default sagaSlice;
